import { Component } from '@angular/core';
import { CaptureHistoryItemTypeBaseComponent } from '../capture-history-item-type-base/capture-history-item-type-base.component';
import { CaptureHistoryItemTitleComponent } from '../capture-history-item-title/capture-history-item-title.component';
import { CaptureHistoryItemBodyComponent } from '../capture-history-item-body/capture-history-item-body.component';

@Component({
    selector: 'app-capture-history-item-type-client-note-removed',
    templateUrl: '../capture-history-item-type-base/capture-history-item-type-base.component.html',
    imports: [CaptureHistoryItemTitleComponent, CaptureHistoryItemBodyComponent]
})
export class CaptureHistoryItemTypeClientNoteRemovedComponent extends CaptureHistoryItemTypeBaseComponent {
  constructor() {
    super();
  }

  get title() {
    return "Client Note Removed";
  }

  get description() {
    return this.captureHistoryItem.data?.content;
  }
}
